import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import { GameAssets } from "src/shared/util/GameAssets";
import gsap from "gsap";

export class Torch extends PIXI.Container {
  private skeleton: Spine;
  private torchSprite: PIXI.Sprite;

  constructor() {
    super();
    this.skeleton = Spine.from({
      skeleton: "wildJson",
      atlas: "wildAtlas",
    });

    this.torchSprite = new PIXI.Sprite(
      GameAssets.textures.gameAtlas.textures["torch.png"],
    );
    this.torchSprite.anchor.set(0.5);
    this.torchSprite.position.set(-5, -100);
    this.torchSprite.scale.set(1);
    this.skeleton.scale.set(0.1, 0.15);
    this.skeleton.alpha = 0; // Initially invisible
    this.addChild(this.skeleton);
    this.addChild(this.torchSprite);
    this.skeleton.state.setAnimation(0, "loading", true).timeScale =
      Math.random() * 0.5 + 0.75;
  }

  public async startTorch(): Promise<void> {
    this.skeleton.visible = true;
    return new Promise((resolve) => {
      gsap.to(this.skeleton, { alpha: 1, duration: 0.5, onComplete: resolve });
    });
  }

  public async endTorch(): Promise<void> {
    return new Promise((resolve) => {
      gsap.to(this.skeleton, {
        alpha: 0,
        duration: 0.5,
        onComplete: () => {
          this.skeleton.visible = false;
          resolve();
        },
      });
    });
  }
}
